import React from 'react';
import SearchFormDate from './SearchFormDate';
import SearchFormPeople from './SearchFormPeople';
import { LocalizedTotalPrice, PeopleParams, SearchParams } from '../types';
import SearchFormArea from './SearchFormArea';
import { eachDayOfInterval } from 'date-fns';

type SearchFormProps = {
  query: SearchParams
  minDate: Date;
  withResortForm?: boolean;
  maxDate?: Date;
  priceCalendar?: { date: string, price: LocalizedTotalPrice }[];
  featuredAreaCodes?: string[];
  otherAreaCodes?: string[];
  handleQueryChange: (query: SearchParams) => void;
  minimumStayDays?: number;
}

const SearchForm: React.FC<SearchFormProps> = ({query, minDate, maxDate, priceCalendar, withResortForm, featuredAreaCodes, otherAreaCodes, handleQueryChange, minimumStayDays}) => {
  const isDateSelected = query.checkinDate && query.checkoutDate;
  const [selectedDateList, setSelectedDateList] = React.useState<Date[]>(() =>
    isDateSelected
      ? eachDayOfInterval({
        start: new Date(query.checkinDate),
        end: new Date(query.checkoutDate),
      })
      : []
  );

  const handleDateListChange = async (selectedDateList: Date[]) => {
    handleQueryChange({
      ...query,
      checkinDate: selectedDateList[0],
      checkoutDate: selectedDateList.slice(-1)[0],
    })
    setSelectedDateList(selectedDateList);
  }

  const handleChangePeople = (people: PeopleParams) => {
    handleQueryChange({
      ...query,
      people: people
    });
  }

  return (
    <>
      {withResortForm &&
        <SearchFormArea
          featuredAreaCodes={featuredAreaCodes}
          otherAreaCodes={otherAreaCodes}
          selectedAreaCodes={query.areaCodes}
          onChangeSelectedAreaCodes={(selectedAreaCodes) => handleQueryChange({ ...query, areaCodes: selectedAreaCodes })}
        />
      }
      <SearchFormDate
        selectedDateList={selectedDateList}
        minDate={minDate}
        maxDate={maxDate}
        priceCalendar={priceCalendar}
        handleDateListChange={handleDateListChange}
        minimumStayDays={minimumStayDays}
        flexGrow={4}
        flexShrink={0}
      />
      <SearchFormPeople 
        people={query.people} 
        handleChangePeople={handleChangePeople}
        flexGrow={2}
        flexShrink={0}
      />
    </>
  );
}

export default SearchForm;
